import { useState } from "react"
import Skeleton from "src/shared/components/layout/skeleton/Skeleton"
import {
    TABLES_DIMENSIONS_SKELETON,
    TABLES_LENGTH_SKELETON,
    TABLES_POSITIONS_SKELETON,
} from "src/shared/constants/localStorage"
import "./SkeletonTableCards.css"

type SavedPosition = { x: number; y: number }
type SavedDimensions = { x: number; y: number }

function parse<T>(key: string, fallback: T): T {
    try {
        return JSON.parse(localStorage.getItem(key) || "null") ?? fallback
    } catch {
        return fallback
    }
}

function SkeletonTableCard() {
    return (
        <div className="table-skeleton__card">
            <div className="table-skeleton__header">
                <Skeleton.Item className="table-skeleton__icon" />
                <div className="table-skeleton__header-right">
                    <Skeleton.Item className="table-skeleton__pill" />
                    <Skeleton.Item className="table-skeleton__pill table-skeleton__pill--lg" />
                </div>
            </div>
            <div className="table-skeleton__body">
                <Skeleton.Item className="table-skeleton__bar" />
            </div>
            <div className="table-skeleton__footer">
                <Skeleton.Item className="table-skeleton__pill" />
            </div>
        </div>
    )
}

function SkeletonTableCards(): JSX.Element {
    const [tablesLength] = useState(Number(localStorage.getItem(TABLES_LENGTH_SKELETON) || 12))
    const [positions] = useState<SavedPosition[]>(() => parse<SavedPosition[]>(TABLES_POSITIONS_SKELETON, []))
    const [dimensions] = useState<SavedDimensions | null>(() =>
        parse<SavedDimensions | null>(TABLES_DIMENSIONS_SKELETON, null)
    )

    // Si ya se cargaron las mesas alguna vez, se reproduce su misma cuadrícula para que
    // el skeleton coincida con el layout real y no haya salto al llegar los datos.
    if (positions.length > 0 && dimensions) {
        return (
            <div className="tables-skeleton__wrapper">
                <div
                    className="tables-skeleton__grid"
                    style={{ gridTemplate: `repeat(${dimensions.x}, 1fr) / repeat(${dimensions.y}, 1fr)` }}
                >
                    {positions.map((pos, index) => (
                        <div key={index} style={{ gridArea: `${pos.y} / ${pos.x} / span 1 / span 1` }}>
                            <SkeletonTableCard />
                        </div>
                    ))}
                </div>
            </div>
        )
    }

    return (
        <div className="tables-skeleton__wrapper">
            <div className="tables-skeleton__cards">
                {Array.from({ length: tablesLength }, (_, index) => (
                    <SkeletonTableCard key={index} />
                ))}
            </div>
        </div>
    )
}

export default SkeletonTableCards
